// import React, { useState } from "react";
// import { Modal, ProgressBar, Form, Row, Col, Button, Spinner } from "react-bootstrap";
// import { CiLocationOn } from "react-icons/ci";
// import { PiCarProfileLight } from "react-icons/pi";
// import { FiEdit2, FiCheckCircle } from "react-icons/fi";
// import InputField from "../common/InputField";
// import { successAlert, errorAlert } from "../common/Alert";
// import { submitRoadsideServiceDetail } from "../../services/Networkcall";

// export const RoadsideServiceRequestModal = ({ show, onClose, bookingIds = [] }) => {

//     const REQUIRED_VEHICLE_FIELDS = ["VIN", "Vehicle_year", "Vehicle_make", "Vehicle_model"];

//     const emptyVehicle = () => ({ VIN: "", Vehicle_year: "", Vehicle_make: "", Vehicle_model: "" });

//     const [location, setLocation] = useState({ Cust_addr1: "", Cust_city: "", Cust_state: "", Cust_zip: "" });
//     const [locationError, setLocationError] = useState({});

//     const locationHandler = (e) => {
//         const { name, value } = e.target;
//         setLocation((prev) => ({ ...prev, [name]: value }));
//         setLocationError((prev) => ({ ...prev, [name]: "" }))

//     };

//     const [vehicles, setVehicles] = useState(bookingIds.map(() => emptyVehicle()));
//     const [vehicleErrors, setVehicleErrors] = useState(bookingIds.map(() => ({})));
//     const [completed, setCompleted] = useState(bookingIds.map(() => false));
//     const [openIndex, setOpenIndex] = useState(0);
//     const [maxReached, setMaxReached] = useState(0);

//     const [loading, setLoading] = useState(false);

//     const handleVehicleChange = (index, e) => {
//         const { name, value } = e.target;
//         setVehicles((prev) => {
//             const next = [...prev];
//             next[index] = { ...next[index], [name]: value };
//             return next;
//         });
//     };

//     const validateVehicle = (index) => {
//         const vehicle = vehicles[index];
//         const errors = {};
//         REQUIRED_VEHICLE_FIELDS.forEach((field) => {
//             if (!vehicle[field]?.trim()) errors[field] = "Required";
//         });
//         setVehicleErrors((prev) => {
//             const next = [...prev];
//             next[index] = errors;
//             return next;
//         });
//         return Object.keys(errors).length === 0;
//     };

//     // -------- progress --------
//     const totalSteps = bookingIds.length + 1; // +1 for location step
//     const stepsDone = ((location.Cust_addr1 && location.Cust_city && location.Cust_state && location.Cust_zip) ? 1 : 0) + completed.filter(Boolean).length;
//     const progress = Math.round((stepsDone / totalSteps) * 100);

//     const handleVehicleContinue = (index) => {

//         if (!validateVehicle(index)) return;

//         const wasAlreadyCompleted = completed[index];

//         setCompleted((prev) => {
//             const next = [...prev];
//             next[index] = true;
//             return next;
//         });

//         if (wasAlreadyCompleted) {
//             setOpenIndex(null);
//             return;
//         }

//         const nextIndex = index + 1;
//         setMaxReached((prev) => Math.max(prev, nextIndex));
//         setOpenIndex(nextIndex);
//         return;
//     };

//     const isAllVehicleCompleted = completed.every(value => value === true);

//     const submitRequestHandler = async () => {
//         console.log(location, vehicles)

//         setLoading(false);
//         try {
//             const payload = {
//                 memberships: vehicles.map((v, i) => ({
//                     membershipId: bookingIds[i]?.membershipId,
//                     vin: v?.VIN,
//                     year: v?.Vehicle_year,
//                     make: v?.Vehicle_make,
//                     model: v?.Vehicle_model,
//                     address1: location?.Cust_addr1,
//                     city: location?.Cust_city,
//                     state: location?.Cust_state,
//                     zipCode: location?.Cust_zip,
//                 })),
//             };
//             const res = await submitRoadsideServiceDetail(payload);
//             if (res?.success) {
//                 successAlert({ message: res?.message || "Request submitted successfully" });
//                 onClose();
//             } else {
//                 errorAlert({ message: res?.message || "something went wrong." });
//             }
//         } catch (err) {
//             errorAlert({ message:err?.response?.data?.message || err?.message || "something went wrong." });
//         } finally {
//             setLoading(false);
//         }
//     }

//     return (
//         <Modal show={show} onHide={onClose} centered dialogClassName="Roadside-service-modal">
//             <Modal.Body className="p-4">
//                 <h4 style={{ color: "#4E78EC" }} className={"text-center fw-bold mb-1"}>
//                     Roadside service Request
//                 </h4>
//                 <p className="text-center text-muted small">
//                     Tell us where you are and what you're driving.
//                 </p>

//                 <ProgressBar now={progress} variant="warning" className="mb-4 mt-0" style={{ height: 5 }} striped />

//                 <Form className="text-start">
//                     <div className="d-flex flex-column gap-3">

//                         {/* ================= LOCATION SECTION ================= */}
//                         <div className="d-flex align-items-center border-bottom pb-1 mb-1">
//                             <span className="text-uppercase small fw-semibold text-primary">
//                                 <CiLocationOn size={20} color={"#4E78EC"} strokeWidth={1} className="mb-1 me-1" />
//                                 Where's the vehicle
//                             </span>
//                         </div>
//                         <Row className="g-3">

//                             <Col xs={12} md={12}>
//                                 <InputField
//                                     name="Cust_addr1"
//                                     label="Address"
//                                     value={location.Cust_addr1}
//                                     onChange={locationHandler}
//                                     required={true}
//                                     className="text-start"
//                                     error={locationError?.Cust_addr1}
//                                 />
//                             </Col>

//                             <Col xs={12} md={5}>
//                                 <InputField
//                                     name="Cust_city"
//                                     label="City"
//                                     value={location.Cust_city}
//                                     onChange={locationHandler}
//                                     required={true}
//                                     error={locationError?.Cust_city}
//                                 />
//                             </Col>
//                             <Col xs={6} md={4}>
//                                 <InputField
//                                     name="Cust_state"
//                                     label="State"
//                                     value={location.Cust_state}
//                                     onChange={locationHandler}
//                                     required={true}
//                                     error={locationError?.Cust_state}
//                                 />
//                             </Col>
//                             <Col xs={6} md={3}>
//                                 <InputField
//                                     name="Cust_zip"
//                                     label="Zip Code"
//                                     value={location.Cust_zip}
//                                     onChange={locationHandler}
//                                     required={true}
//                                     error={locationError?.Cust_zip}
//                                 />
//                             </Col>
//                         </Row>

//                         {/* ================= VEHICLE SECTIONS (one per booking id) ================= */}
//                         {bookingIds.map((booking, idx) => {

//                             const bookingId = booking.bookingId;

//                             const isOpen = idx === openIndex;
//                             const isDone = completed[idx];
//                             const isUpcoming = !isDone && idx > maxReached;

//                             if (isUpcoming) return null; // not reached yet — stays hidden

//                             if (isDone && !isOpen) {
//                                 const vehicle = vehicles[idx];
//                                 return (
//                                     <div
//                                         key={bookingId}
//                                         className="d-flex align-items-center justify-content-between border rounded-3 p-2 mb-1 vehicle-summary-card"
//                                         style={{ cursor: "pointer" }}
//                                         onClick={() => setOpenIndex(idx)}
//                                     >
//                                         <div className="d-flex align-items-center gap-2">
//                                             <FiCheckCircle size={16} color="#2e7d32" />
//                                             <span className="fw-semibold small">{vehicle.VIN}</span>
//                                         </div>
//                                         <div className="d-flex align-items-center gap-2">
//                                             <span className="booking-id-badge rounded-4">Booking ID : {bookingId}</span>
//                                             <FiEdit2 size={14} className="text-muted" />
//                                         </div>
//                                     </div>

//                                 );
//                             }

//                             // Open form for this vehicle (fresh or re-opened for edit)
//                             const vehicle = vehicles[idx];
//                             const errors = vehicleErrors[idx] || {};

//                             return (
//                                 <div key={bookingId} className="d-flex flex-column gap-3">
//                                     <div className="d-flex align-items-center justify-content-between border-bottom pb-1 mb-1 mt-2">
//                                         <span className="text-uppercase small fw-semibold text-primary">
//                                             <PiCarProfileLight size={20} color={"#4E78EC"} strokeWidth={2} className="mb-1 me-1" />
//                                             What's the vehicle
//                                             {bookingIds?.length > 0 && (
//                                                 <span className="text-muted normal-case ms-1">({idx + 1} of {bookingIds?.length})</span>
//                                             )}
//                                         </span>
//                                         <span className="booking-id-badge rounded-4">Booking ID : {bookingId}</span>
//                                     </div>

//                                     <InputField
//                                         name="VIN"
//                                         label="VIN"
//                                         value={vehicle.VIN}
//                                         onChange={(e) => handleVehicleChange(idx, e)}
//                                         required={true}
//                                         error={errors.VIN}
//                                     />

//                                     <Row className="g-3">
//                                         <Col xs={6} md={3}>
//                                             <InputField
//                                                 name="Vehicle_year"
//                                                 label="Vehicle Year"
//                                                 type="number"
//                                                 maxLength={4}
//                                                 min={"1900"}
//                                                 placeholder="YYYY"
//                                                 pattern={"\d{4}"}
//                                                 value={vehicle.Vehicle_year}
//                                                 onChange={(e) => handleVehicleChange(idx, e)}
//                                                 required={true}
//                                                 error={errors.Vehicle_year}
//                                             />
//                                         </Col>
//                                         <Col xs={6} md={4}>
//                                             <InputField
//                                                 name="Vehicle_make"
//                                                 label="Vehicle Make"
//                                                 value={vehicle.Vehicle_make}
//                                                 onChange={(e) => handleVehicleChange(idx, e)}
//                                                 required={true}
//                                                 error={errors.Vehicle_make}
//                                             />
//                                         </Col>
//                                         <Col xs={12} md={5}>
//                                             <InputField
//                                                 name="Vehicle_model"
//                                                 label="Vehicle Model"
//                                                 value={vehicle.Vehicle_model}
//                                                 onChange={(e) => handleVehicleChange(idx, e)}
//                                                 required={true}
//                                                 error={errors.Vehicle_model}
//                                             />
//                                         </Col>
//                                     </Row>

//                                     <Button
//                                         size="md"
//                                         onClick={() => handleVehicleContinue(idx)}
//                                         className="mt-1"
//                                         disabled={loading}
//                                     > {isDone ? "Save" : "Continue"}
//                                     </Button>
//                                 </div>
//                             );
//                         })}

//                         {isAllVehicleCompleted && <Button size="md" className="w-100 mt-3" onClick={submitRequestHandler}>Submit</Button>}

//                     </div>
//                 </Form>
//             </Modal.Body>
//         </Modal>
//     );
// };





import { useState } from "react";
import { submitRoadsideServiceDetail } from "../../services/Networkcall";
import { errorAlert } from "./Alert";
import { Button, Card, Col, Form, Image, Modal, ProgressBar, Row } from "react-bootstrap";
import { Loader } from "./Loader";
import { FaApple, FaCar, FaGooglePlay, FaLocationDot, FaUser } from "react-icons/fa6";
import { Link } from "react-router-dom";
import { IoIosCalendar } from "react-icons/io";
import InputField from "../common/InputField";

export const RoadsideServiceRequestModal = ({ show, onClose, bookingIds }) => {
    const [loading, setLoading] = useState(false)
    const [indata, setIndata] = useState({ "Cust_addr1": "", "Cust_city": "", "Cust_state": "", "Cust_zip": "", "VIN": "", "Vehicle_year": "", "Vehicle_make": "", "Vehicle_model": "" })
    const [error, setError] = useState("");
    const [showResponseModal, setShowResponseModal] = useState(false);
    const [memberdetail, setMemberdetail] = useState(null);

    const inputhandler = (e) => {
        const { name, value } = e.target;
        setIndata((pre) => ({ ...pre, [name]: value }));
        setError((pre) => ({ ...pre, [name]: "" }));
    }

    const isLocationDone = !!(indata.Cust_addr1 && indata.Cust_city && indata.Cust_state && indata.Cust_zip);
    const isVehicleDone = !!(indata.VIN && indata.Vehicle_year && indata.Vehicle_make && indata.Vehicle_model);
    const totalSteps = 2;
    const completedSteps = Number(isLocationDone) + Number(isVehicleDone);
    const progress = Math.round((completedSteps / totalSteps) * 100);

    const submitHandler = async (e) => {
        e.preventDefault();
        e.stopPropagation();

        let isValid = true;
        if (!indata?.Cust_addr1.trim()) { setError((pre) => ({ ...pre, "Cust_addr1": "Required" })); isValid = false; }
        if (!indata?.Cust_city.trim()) { setError((pre) => ({ ...pre, "Cust_city": "Required" })); isValid = false; }
        if (!indata?.Cust_state.trim()) { setError((pre) => ({ ...pre, "Cust_state": "Required" })); isValid = false; }
        if (indata?.Cust_zip.length !== 5) { setError((pre) => ({ ...pre, "Cust_zip": "Invalid ZIP" })); isValid = false; }
        if (!indata?.Cust_zip.trim()) { setError((pre) => ({ ...pre, "Cust_zip": "Required" })); isValid = false; }
        if (indata?.VIN.length <= 10) { setError((pre) => ({ ...pre, "VIN": "VIN length should be at least 10 characters" })); isValid = false; }
        if (!indata?.VIN.trim()) { setError((pre) => ({ ...pre, "VIN": "Required" })); isValid = false; }
        if (!indata?.Vehicle_make.trim()) { setError((pre) => ({ ...pre, "Vehicle_make": "Required" })); isValid = false; }
        if (!indata?.Vehicle_model.trim()) { setError((pre) => ({ ...pre, "Vehicle_model": "Required" })); isValid = false; }
        if (!indata?.Vehicle_year.trim()) { setError((pre) => ({ ...pre, "Vehicle_year": "Required" })); isValid = false; }
        if (indata?.Vehicle_year.length !== 4) { setError((pre) => ({ ...pre, "Vehicle_year": "Invalid Year" })); isValid = false; }


        const ob = {
            "membershipId": bookingIds[0]?.membershipId,
            "address1": indata?.Cust_addr1,
            "city": indata?.Cust_city,
            "state": indata?.Cust_state,
            "zipCode": indata?.Cust_zip,
            "vin": indata?.VIN,
            "make": indata?.Vehicle_make,
            "model": indata?.Vehicle_model,
            "year": indata?.Vehicle_year
        }
        const payload = { "memberships": [ob] }

        if (isValid) {

            setLoading(true);
            const res = await submitRoadsideServiceDetail(payload);
            if (res?.success) {
                setLoading(false);
                setShowResponseModal(true);
                console.log(res.data,res?.data[0] )
                setMemberdetail(res?.data[0] || {});
                onClose();
            } else {
                setLoading(false);
                errorAlert({ message: res?.message || "Something went wrong" });
            }

            setLoading(false);
        }
    }

    console.log(showResponseModal,memberdetail )
    const closeModal = () => {
        setShowResponseModal(false);
        setMemberdetail(null);
        onClose();
    }


    return (<>
        <Loader show={loading} />

        <Modal show={show} onHide={onClose} centered backdrop='static' dialogClassName="legal-modal">
            <Modal.Body className="p-4">
                <div className="d-flex gap-3 mb-2" >
                    <Image src="/assets/images/truck-shield.png" width={40} height={50} className="mb-1" />
                    <div>
                        <h4 style={{color:"#002488"}} className={'fw-bold mb-1'}>
                            Roadside service Request
                        </h4>
                        <p className="text-center text-muted small mb-1">
                            Tell us about your vehicle so we can assist you faster.
                        </p>
                    </div>
                </div>


                <ProgressBar now={progress} variant="warning" className="mb-4 mt-3" style={{ height: 4 }} striped />

                <Form className="text-start">
                    <div className="d-flex flex-column gap-3" >

                        <Card className="shadow-sm border rounded-3 bg-white p-3">
                            {/* Section: Location */}
                            <div className="d-flex gap-1 mb-2" >
                                <div className="rounded-3 border p-2 bg-primary"  >
                                    <FaLocationDot size={25} color="white" />
                                </div>
                                <div className="ms-2">
                                    <h6 style={{color:"#002488"}} className={' fw-bold my-1 text-uppercase'}  >
                                        Registration Address
                                    </h6>
                                    <p className="text-center text-muted small mb-0">
                                        Enter the address where your vehicle is registered.
                                    </p>
                                </div>
                            </div>


                            <InputField
                                name="Cust_addr1"
                                label="Address"
                                onChange={inputhandler}
                                required={true}
                                value={indata.Cust_addr1}
                                className="text-start mb-2"
                                error={error?.Cust_addr1}
                            />

                            <Row className="g-3">
                                <Col xs={12} md={5}>
                                    <InputField
                                        name="Cust_city"
                                        label="City"
                                        onChange={inputhandler}
                                        value={indata.Cust_city}
                                        required={true}
                                        error={error?.Cust_city}
                                    />
                                </Col>
                                <Col xs={6} md={4}>
                                    <InputField
                                        name="Cust_state"
                                        label="State"
                                        onChange={inputhandler}
                                        value={indata.Cust_state}
                                        required={true}
                                        error={error?.Cust_state}
                                    />
                                </Col>
                                <Col xs={6} md={3}>
                                    <InputField
                                        name="Cust_zip"
                                        label="Zip Code"
                                        onChange={inputhandler}
                                        value={indata.Cust_zip}
                                        required={true}
                                        error={error?.Cust_zip}
                                    />
                                </Col>
                            </Row>

                        </Card>

                        <Card className="shadow-sm border rounded-3 bg-white p-3">

                            {/* Section: Vehicle  */}

                            <div className="mb-2 d-flex gap-1"  >
                                <div className="rounded-3 border p-2 bg-primary"  >
                                    <FaCar size={25} color="white" />
                                </div>
                                <div className="ms-2">
                                    <h6 style={{color:"#002488"}} className={' fw-bold my-1 text-uppercase'}>
                                        Vehicle Information
                                    </h6>
                                    <small className="text-center text-muted  mb-0">
                                        Tell us about the vehicle you need help with.
                                    </small>
                                </div>
                            </div>

                            <div className="mb-3">
                                <InputField
                                    name="VIN"
                                    label="VIN"
                                    onChange={inputhandler}
                                    value={indata.VIN}
                                    required={true}
                                    error={error?.VIN}
                                />
                                <small className="text-muted fs-8">Found on the dashboard, the driver's door jamb sticker, or your registration.</small>
                            </div>

                            <Row className="g-3">
                                <Col xs={6} md={4}>
                                    <InputField
                                        name="Vehicle_year"
                                        type="number"
                                        label="Vehicle Year"
                                        onChange={inputhandler}
                                        min={1900}
                                        max={3000}
                                        maxLength={4}
                                        value={indata.Vehicle_year}
                                        required={true}
                                        error={error?.Vehicle_year}
                                    />
                                </Col>
                                <Col xs={6} md={4}>
                                    <InputField
                                        name="Vehicle_make"
                                        label="Vehicle Make"
                                        onChange={inputhandler}
                                        value={indata.Vehicle_make}
                                        required={true}
                                        error={error?.Vehicle_make}
                                    />
                                </Col>
                                <Col xs={12} md={4}>
                                    <InputField
                                        name="Vehicle_model"
                                        label="Vehicle Model"
                                        onChange={inputhandler}
                                        value={indata.Vehicle_model}
                                        required={true}
                                        error={error?.Vehicle_model}
                                    />
                                </Col>
                            </Row>

                        </Card>

                        <div className="d-flex gap-2 bg-light-primary rounded-2 p-3 ali" >
                            <Image src="/assets/images/lock-shield.png" width={40} height={50} className="mt-2" />
                            <div>
                                <p className={'fw-bold mb-0 fs-6'}>Your information is secure</p>
                                <p className="text-muted small mb-0">We use your details only to provide roadside assistance and do not share them with third parties.</p>
                            </div>
                        </div>

                        <Button
                            size="md"
                            onClick={submitHandler}
                            className={'mt-3'}
                            disabled={loading}
                        >Continue</Button>


                    </div>
                </Form>
            </Modal.Body>
        </Modal>


        {memberdetail?.memberNumber && showResponseModal &&
            <Modal show={showResponseModal} onHide={onClose} centered backdrop='static' dialogClassName="legal-modal">
                <Modal.Body className="p-4 bg-white rounded-3">
                    <div className="mb-2 d-flex gap-3"  >
                        <Image src="../assets/images/truck-shield.png" width={40} height={50} className="mb-1" />
                        <div>
                            <h4 style={{color:"#002488"}}  className={'fw-bold mb-1'} variant={'h4'}>
                                RoadsideMASTERS Benefits
                            </h4>
                            <p className="text-muted small mb-1">
                                Your membership is active.
                            </p>
                        </div>
                    </div>


                    <ProgressBar now={50} variant="warning" className="mb-4" style={{ height: 4 }} striped />


                    <div className={'p-2 w-100 bg-light-primary shadow-sm border mb-2'}>
                        <div className="d-flex gap-3">
                            <Image src="../assets/images/circle-check.png" width={50} height={50} />
                            <h4 variant={'h4'} className={'fw-bold'} >Membership Activated</h4>
                        </div>
                        <div className="d-flex gap-1 justify-content-center mt-2">
                            <div className="d-flex gap-2 bg-white border p-2 rounded shadow-sm">
                                <div className="px-2 p-1 d-flex align-items-center shadow rounded-circle"><FaUser color="#0055ff" size={22} /></div>
                                <div>
                                    <p className="mb-0 small  text-nowrap">Member ID :</p>
                                    <strong className="fs-7">{memberdetail?.memberNumber || ''}</strong>
                                </div>
                            </div>

                            <div className="d-flex gap-2 bg-white border p-2 rounded shadow-sm">
                                <div className="px-2 p-1 d-flex align-items-center  shadow rounded-circle"><FaLocationDot color="#0055ff" size={25} /></div>
                                <div>
                                    <p className="mb-0 small text-nowrap">ZIP Code :</p>
                                    <strong className="fs-7">{memberdetail?.zipCode || ''}</strong>
                                </div>
                            </div>

                            <div className="d-flex gap-2 bg-white border p-2 rounded shadow-sm">
                                <div className="px-2 p-1 d-flex align-items-center shadow rounded-circle"><IoIosCalendar color="#0055ff" size={25} /></div>
                                <div>
                                    <p className="mb-0 small">Effective :</p>
                                    <strong className="fs-7">{memberdetail?.effectiveDate || new Date()}</strong>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className={'shadow mb-2  bg-white p-2 w-100'}>
                        <div className="d-flex gap-3 align-items-start"  >
                            <div className="bg-primary p-2 rounded-3 text-white text-uppercase text-center">
                                <p className="mb-0 fw-bold lh-1 mt-1">Step</p>
                                <strong className="fs-3 mb-0 lh-1">1</strong>
                            </div>
                            <div>
                                <h6 className={'mb-0 fw-bold'}>Download the App</h6>
                                <small>Request service and share your GPs location. </small>
                                <div className="mt-2">
                                    <Link to={'https://apps.apple.com/in/app/roadsidemasters-com/id1422699064'} className="btn btn-outline-dark  me-3" target="_blank"><FaApple size={30} className="mb-1" /> App Store</Link>
                                    <Link to={'https://play.google.com/store/apps/details?id=com.roadsidemasters.main&pcampaignid=web_share'} className="btn btn-outline-dark" target="_blank"><FaGooglePlay size={28} className="mb-1" /> Google Play</Link>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className={'shadow mb-2  bg-white p-2 w-100'}>
                        <div className="d-flex gap-3 align-items-start" >
                            <div className="bg-primary p-2 rounded-3 text-white text-uppercase text-center">
                                <p className="mb-0 fw-bold lh-1 mt-1">Step</p>
                                <strong className="fs-3 mb-0 lh-1">2</strong>
                            </div>
                            <div>
                                <h6 variant={"h6"} className={'mb-0 fw-bold'}>Access Your Benefits</h6>
                                <p className=" small">Open the member portal and view your card, handbook, and profile</p>
                                <Link to={'http://www.roadsidemasters.com/memberlogin/'} className="btn btn-outline-primary w-100 fw-bold mb-1" target="_blank"> Open Member Portal</Link>
                                <Link to={'http://www.roadsidemasters.com/memberlogin/'} className="text-decoration-none ms-4 text-primary" target="_blank"> roadsidemasters.com/memberlogin</Link>
                            </div>
                        </div>
                    </div>

                    <div className={'shadow mb-3 bg-white p-2 w-100'}>
                        <div className="d-flex gap-3 align-items-start">
                            <div className="bg-primary p-2 rounded-3 text-white text-uppercase text-center">
                                <p className="mb-0 fw-bold lh-1 mt-1">Step</p>
                                <strong className="fs-3 mb-0 lh-1">3</strong>
                            </div>
                            <div className="d-flex flex-column w-100">
                                <h6  className={'mb-0 fw-bold'}>Need Roadside Assistance ?</h6>
                                <small>Call before arranging service.</small>
                                <h3 className={'mb-0 fw-bold text-center'} color={'#006eff'}> 1-800-395-4908</h3>
                                <small className="text-center">Available 24/7</small>
                            </div>
                        </div>
                    </div>

                    <div className="d-flex gap-3 bg-light-primary rounded-4 p-3 align-items-center justify-content-center">
                        <Image src="../../assets/images/lock-shield.png" width={30} height={35} />
                        <small><strong>Important :</strong> Service must be request through RoadsideMASTERS for the registered vehicle.</small>
                    </div>

                    <Button
                        size="md"
                        onClick={closeModal}
                        className={'mt-3 fw-bold w-100'}
                        disabled={loading}
                    >Continue to Trucktuck</Button>

                </Modal.Body>
            </Modal>
        }

    </>
    );
};